const EachSalesRecord = ({ record, userCurrency }) => {
  return (
    <>
      <div className='eachsalesRecordDiv'>
        <div>
          <img
            className='ImageSalesRec394'
            src={`${record.productImage.split("/upload/")[0]}/upload/f_auto,q_auto,w_61/${record.productImage.split("/upload/")[1]}`}
          />
          <div>
            <p className='titleSR494'>{record.name}</p>
            <p>
              unit price: {userCurrency} {record.unitPrice?.toLocaleString()}
            </p>
          </div>
          <p className='quantityDiv3844'>{record.quantity}</p>
        </div>
        <div>
          <p className='Datesds38453'>{record.purchaseDate.split("T")[0]}</p>
          <p>
            {userCurrency} {record.totalPrice.toLocaleString()}
          </p>
        </div>
      </div>
    </>
  );
};

export default EachSalesRecord;
